import type { InfinityPage, PageLimit } from "@/shared/api/types";

export type AdminListQuery = {
	search?: string;
	isActive?: boolean;
	page?: number;
	limit?: PageLimit;
	sort?: string;
	order?: "ASC" | "DESC";
	type?: string;
};

export function toAdminSearchParams(query: AdminListQuery): URLSearchParams {
	const search = new URLSearchParams();
	search.set("page", String(query.page ?? 1));
	search.set("limit", String(query.limit ?? 20));
	if (query.search && query.search.trim().length >= 3) {
		search.set("search", query.search.trim());
	}
	if (query.isActive !== undefined) {
		search.set("isActive", String(query.isActive));
	}
	if (query.sort) {
		search.set("sort", query.sort);
	}
	if (query.order) {
		search.set("order", query.order);
	}
	if (query.type) {
		search.set("type", query.type);
	}
	return search;
}

export type Paged<T> = InfinityPage<T> & {
	currentPage?: number;
	totalPages?: number;
};
